import type { OpsTemplate } from '../types';

/**
 * Built-in intake snapshot applied to every new flow at creation time.
 *
 * This is intentionally tiny: Screeners + Committed.
 * Later, ops can apply templates which are appended/merged below.
 */
export function buildIntakeTemplate(params: {
  createdAt: number;
  createdBy: string;
}): OpsTemplate {
  const { createdAt, createdBy } = params;
  return {
    templateId: 'intake_v1',
    title: 'Intake',
    description: 'Initial screening + commitment before selecting execution templates.',
    checkpoints: [
      {
        checkpointId: 'intake.screeners',
        title: 'Screeners',
        order: 0,
        tasks: [
          {
            taskId: 'intake.screeners.complete',
            title: 'Screeners complete',
            order: 0,
            required: true,
            helpText: 'Mark when the school has passed initial screening.',
          },
        ],
      },
      {
        checkpointId: 'intake.committed',
        title: 'Committed',
        order: 1,
        tasks: [
          {
            taskId: 'intake.committed.complete',
            title: 'Committed (verbal or written)',
            order: 0,
            required: true,
            helpText: 'Mark when decision-maker commitment is confirmed (not assumed).',
          },
          {
            taskId: 'intake.committed.deliveryMode',
            title: 'Set squad format (in-person vs online)',
            order: 1,
            required: true,
            logisticId: 'squad.deliveryMode',
            helpText: 'Mark whether this squad is in-person or online.',
          },
        ],
      },
    ],
    createdAt,
    createdBy,
    updatedAt: createdAt,
    updatedBy: createdBy,
  };
}

